(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[251],{

/***/ "qumz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dishes", function() { return Dishes; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Dishes = function Dishes(_ref) {
  var title = _ref.title,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["title"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 138 104"
  }, rest), title && __jsx("title", null, title), __jsx("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, __jsx("g", {
    fill: "#005685",
    fillRule: "nonzero"
  }, __jsx("path", {
    d: "M133.6 96.9h-7.4V74.8c0-28-20-51.3-46.4-56.6 1.1-1.8 1.7-3.9 1.7-6.1C81.5 5.6 76.2.3 69.7.3c-6.5 0-11.8 5.3-11.8 11.8 0 2.1.5 4 1.5 5.7-27.5 4.4-48.5 28.3-48.5 57v22.1H3.5c-1.9 0-3.4 1.5-3.4 3.4s1.5 3.4 3.4 3.4h130.3c1.9 0 3.4-1.5 3.4-3.4-.2-1.9-1.7-3.4-3.6-3.4zM69.7 7.1c2.7 0 5 2.2 5 5 0 2.7-2.2 5-5 5-2.7 0-5-2.2-5-5 0-2.7 2.2-5 5-5zM17.6 74.8c0-28.1 22.8-50.9 50.9-50.9 28.1 0 50.9 22.8 50.9 50.9v22.1H114V69.6c0-10.3-8.4-18.7-18.7-18.7H41.9c-10.3 0-18.7 8.4-18.7 18.7v27.3h-5.4V74.8h-.2zm89.5 1.3c-3-1.4-5.5-4.4-7-7.5-.6-1.2-1.8-1.9-3.1-1.9s-2.5.7-3.1 1.9c-2 4.1-6 8.3-10.4 8.3s-8.4-4.2-10.4-8.3c-.6-1.2-1.8-1.9-3.1-1.9s-2.5.7-3.1 1.9c-2 4.1-6 8.3-10.4 8.3-4.6 0-8.5-4.4-10.3-8.1-.6-1.2-1.8-1.9-3.1-1.9s-2.5.7-3.1 1.9c-1.9 3.8-5.7 8.1-10.3 8.1v-7.3c0-6.6 5.3-11.9 11.9-11.9H95c6.6 0 11.9 5.3 11.9 11.9v6.5h.2zM29.9 96.9V83.7c5.6 0 10.2-3.2 13.4-7.2 3.2 4 7.8 7.2 13.4 7.2 5.7 0 10.3-3.2 13.5-7.3 3.2 4 7.8 7.3 13.5 7.3s10.3-3.2 13.5-7.3c2.5 3.2 5.9 5.9 10.1 6.8v13.6H29.9v.1z"
  }))));
};

/***/ })

}]);